function _typeof(obj) {
  if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") {
    _typeof = function _typeof(obj) {
      return typeof obj;
    };
  } else {
    _typeof = function _typeof(obj) {
      return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
    };
  }
  return _typeof(obj);
}
function _objectSpread(target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i] != null ? arguments[i] : {};
    var ownKeys = Object.keys(source);
    if (typeof Object.getOwnPropertySymbols === 'function') {
      ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function (sym) {
        return Object.getOwnPropertyDescriptor(source, sym).enumerable;
      }));
    }
    ownKeys.forEach(function (key) {
      _defineProperty(target, key, source[key]);
    });
  }
  return target;
}
function _classCallCheck(instance, Constructor) {
  if (!(instance instanceof Constructor)) {
    throw new TypeError("Cannot call a class as a function");
  }
}
function _defineProperties(target, props) {
  for (var i = 0; i < props.length; i++) {
    var descriptor = props[i];
    descriptor.enumerable = descriptor.enumerable || false;
    descriptor.configurable = true;
    if ("value" in descriptor) descriptor.writable = true;
    Object.defineProperty(target, descriptor.key, descriptor);
  }
}
function _createClass(Constructor, protoProps, staticProps) {
  if (protoProps) _defineProperties(Constructor.prototype, protoProps);
  if (staticProps) _defineProperties(Constructor, staticProps);
  return Constructor;
}
function _possibleConstructorReturn(self, call) {
  if (call && (_typeof(call) === "object" || typeof call === "function")) {
    return call;
  }
  return _assertThisInitialized(self);
}
function _getPrototypeOf(o) {
  _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) {
    return o.__proto__ || Object.getPrototypeOf(o);
  };
  return _getPrototypeOf(o);
}
function _inherits(subClass, superClass) {
  if (typeof superClass !== "function" && superClass !== null) {
    throw new TypeError("Super expression must either be null or a function");
  }
  subClass.prototype = Object.create(superClass && superClass.prototype, {
    constructor: {
      value: subClass,
      writable: true,
      configurable: true
    }
  });
  if (superClass) _setPrototypeOf(subClass, superClass);
}
function _setPrototypeOf(o, p) {
  _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) {
    o.__proto__ = p;
    return o;
  };
  return _setPrototypeOf(o, p);
}
function _assertThisInitialized(self) {
  if (self === void 0) {
    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  }
  return self;
}
function _defineProperty(obj, key, value) {
  if (key in obj) {
    Object.defineProperty(obj, key, {
      value: value,
      enumerable: true,
      configurable: true,
      writable: true
    });
  } else {
    obj[key] = value;
  }
  return obj;
}
import * as React from 'react';
import classnames from 'classnames';
import FieldContainer from '../FieldContainer';
import handleEvent from '../libs/handleEvent';
import injectStyles from '../jss';
import { IconSelect } from '../Icons';
import styles from './Select.jss';
export var Select = /*#__PURE__*/
function (_React$PureComponent) {
  _inherits(Select, _React$PureComponent);
  function Select() {
    var _getPrototypeOf2;
    var _this;
    _classCallCheck(this, Select);
    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }
    _this = _possibleConstructorReturn(this, (_getPrototypeOf2 = _getPrototypeOf(Select)).call.apply(_getPrototypeOf2, [this].concat(args)));
    _defineProperty(_assertThisInitialized(_assertThisInitialized(_this)), "renderOption", function (option, index) {
      var text = option.text,
        value = option.value;
      return React.createElement("option", {
        key: "".concat(index, "_").concat(String(value)),
        value: _this.getSanitizedValue(value)
      }, text || value);
    });
    _defineProperty(_assertThisInitialized(_assertThisInitialized(_this)), "onBlur", function (event) {
      var _this$props = _this.props,
        name = _this$props.name,
        onBlur = _this$props.onBlur;
      handleEvent(name, onBlur, event);
    });
    _defineProperty(_assertThisInitialized(_assertThisInitialized(_this)), "onChange", function (event) {
      var _this$props2 = _this.props,
        name = _this$props2.name,
        onChange = _this$props2.onChange;
      handleEvent(name, onChange, event);
    });
    _defineProperty(_assertThisInitialized(_assertThisInitialized(_this)), "onFocus", function (event) {
      var _this$props3 = _this.props,
        name = _this$props3.name,
        onFocus = _this$props3.onFocus;
      handleEvent(name, onFocus, event);
    });
    return _this;
  }
  _createClass(Select, [{
    key: "getSanitizedValue",
    value: function getSanitizedValue(value) {
      if (typeof value === 'boolean') {
        return value.toString();
      }
      return value || '';
    }
  }, {
    key: "render",
    value: function render() {
      var _classnames;
      var _this$props4 = this.props,
        classes = _this$props4.classes,
        disabled = _this$props4.disabled,
        error = _this$props4.error,
        name = _this$props4.name,
        options = _this$props4.options,
        success = _this$props4.success,
        value = _this$props4.value;
      var sanitizedValue = this.getSanitizedValue(value);
      var hasIndicator = Boolean(error || success);
      if (!options.length && sanitizedValue) {
        options.push({
          value: sanitizedValue,
          text: String(sanitizedValue)
        });
      }
      var className = classnames((_classnames = {}, _defineProperty(_classnames, classes.select, true), _defineProperty(_classnames, classes.select__disabled, disabled), _defineProperty(_classnames, classes.select__withIndicator, hasIndicator), _classnames));
      return React.createElement(FieldContainer, this.props, React.createElement("select", {
        id: name,
        key: "select",
        name: name,
        onBlur: this.onBlur,
        onChange: this.onChange,
        onFocus: this.onFocus,
        className: className,
        value: sanitizedValue,
        disabled: disabled
      }, React.createElement("option", {
        disabled: true,
        key: "blank",
        value: ""
      }), options.map(this.renderOption)), React.createElement("div", {
        className: classnames(classes.icon, hasIndicator && classes.icon__withIndicator)
      }, React.createElement(IconSelect, {
        className: classes.selectIcon
      })));
    }
  }]);
  return Select;
}(React.PureComponent);
_defineProperty(Select, "styleRoot", 'Select');
_defineProperty(Select, "defaultProps", _objectSpread({}, FieldContainer.defaultProps));
export default injectStyles(styles)(Select);